import React, { useState, useEffect } from "react";
import { Terminal, Check, Activity } from "lucide-react";

const commandSequence = [
  { type: "input", text: "xynk session start --console PS5-02 --player 'Rahul M.'" },
  { type: "log", text: "[SESSION] Allocating PlayStation 5 (Console 02) to Rahul M." },
  { type: "log", text: "[BILLING] Live tracking initialized. Rate: ₹180/hr." },
  
  { type: "delay", ms: 800 },
  { type: "input", text: "xynk order add --console PS5-02 --item 'Cheese Maggi' --qty 1" },
  { type: "log", text: "[INVENTORY] 1x Cheese Maggi added to bill. Stock: 41 remaining." },
  { type: "input", text: "xynk order add --console PS5-02 --item 'Monster Energy' --qty 1" },
  { type: "log", text: "[INVENTORY] 1x Monster Energy added to bill. Stock: 14 remaining." },
  
  { type: "delay", ms: 1000 },
  { type: "input", text: "xynk session pause --console PS5-02 --reason 'Dinner Break'" },
  { type: "log", text: "[OK] Session timer paused at 0:45:12. Billing suspended." },
  
  { type: "delay", ms: 900 },
  { type: "input", text: "xynk session resume --console PS5-02" },
  { type: "log", text: "[OK] Session timer resumed. Billing active." },
  
  { type: "delay", ms: 800 },
  { type: "input", text: "xynk session status --console PS5-02" },
  { type: "status", text: "PS5-02: ACTIVE | Gamer: Rahul M. | Time: 1:15:00 | Play: ₹225 | Food: ₹200 | Total: ₹425" },
  
  { type: "delay", ms: 1100 },
  { type: "input", text: "xynk session settle --console PS5-02 --payment UPI" },
  { type: "log", text: "[UPI] Generating dynamic UPI QR code for ₹425..." },
  { type: "log", text: "[OK] Payment verified successfully via dynamic QR." },
  { type: "success", text: "[SUCCESS] Session settled. Invoice #3842 printed. PS5-02 is now AVAILABLE." }
];

export default function TerminalShowcase() {
  const [lines, setLines] = useState([]);
  const [isThinking, setIsThinking] = useState(false);

  useEffect(() => {
    let currentStep = 0;
    let timeoutId = null;

    const runSequence = () => {
      if (currentStep >= commandSequence.length) {
        timeoutId = setTimeout(() => {
          setLines([]);
          currentStep = 0;
          runSequence();
        }, 5000);
        return;
      }

      const step = commandSequence[currentStep];

      if (step.type === "delay") {
        setIsThinking(true);
        timeoutId = setTimeout(() => {
          setIsThinking(false);
          currentStep++;
          runSequence();
        }, step.ms);
      } else if (step.type === "input") {
        let typedText = "";
        let charIndex = 0;
        setLines(prev => [...prev, { type: "input", text: "" }]);

        const typeChar = () => {
          if (charIndex < step.text.length) {
            typedText += step.text[charIndex];
            setLines(prev => {
              const updated = [...prev];
              updated[updated.length - 1].text = `> ${typedText}`;
              return updated;
            });
            charIndex++;
            timeoutId = setTimeout(typeChar, 40);
          } else {
            currentStep++;
            runSequence();
          }
        };
        typeChar();
      } else {
        setLines(prev => [...prev, step]);
        currentStep++;
        timeoutId = setTimeout(runSequence, 350);
      }
    };

    runSequence();
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="terminal-window">
      <div className="terminal-header">
        <div className="terminal-header-left">
          <Terminal size={14} className="terminal-icon" />
          <span className="terminal-title">xynk-cloud-cli</span>
        </div>
        <div className="terminal-header-right">
          <span className="window-dot dot-red" />
          <span className="window-dot dot-yellow" />
          <span className="window-dot dot-green" />
        </div>
      </div>
      <div className="terminal-body">
        {lines.map((line, i) => (
          <div key={i} className="terminal-line">
            {line.type === "input" && (
              <span className="terminal-input">{line.text}</span>
            )}
            {line.type === "log" && (
              <span className="terminal-log">{line.text}</span>
            )}
            {line.type === "status" && (
              <span className="terminal-status-log">{line.text}</span>
            )}
            {line.type === "success" && (
              <span className="terminal-success-log">
                <Check size={12} className="terminal-check-icon" />
                {line.text}
              </span>
            )}
          </div>
        ))}
        {isThinking && (
          <div className="terminal-thinking">
            <Activity size={12} className="terminal-pulse" />
            <span>Thinking...</span>
            <span className="terminal-dots-bounce">
              <span className="bounce-dot dot-1" />
              <span className="bounce-dot dot-2" />
              <span className="bounce-dot dot-3" />
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
